module.exports = __webpack_public_path__ + "img/39_004_012_c.dc418678.png";